import { useEffect, useState } from 'react';

import App from './App';
import fetchJson from 'Utils/fetchJson';
import { globalTrackerAPIRoot } from 'Constants/locations';

const PageRoot = (props) => {
  const [globalStatistics, setGlobalStatistics] = useState(props.globalStatistics);
  const [globalCounts, setGlobalCounts] = useState(props.globalCounts);
  const [regionalCounts, setRegionalCounts] = useState(props.regionalCounts);
  const [hasFetched, setHasFetched] = useState(false);

  const refetchData = async() => {
    const [
      globalStatistics,
      globalCounts,
      regionalCounts,
    ] = await Promise.all([
      fetchJson(`${globalTrackerAPIRoot}/statistics.json`),
      fetchJson(`${globalTrackerAPIRoot}/counts/all.json`),
      fetchJson(`${globalTrackerAPIRoot}/regions/counts/all.json`),
    ]);

    setGlobalStatistics(globalStatistics);
    setGlobalCounts(globalCounts);
    setRegionalCounts(regionalCounts);
    setHasFetched(true);
  };

  useEffect(() => {
    refetchData();
  }, [props.globalStatistics]);

  // temp very nuclear fix for basePath app when getStaticProps doesn't run...
  // if (!props.globalStatistics) location.reload();

  return globalStatistics ? (
    <App {...{
      ...props,
      globalStatistics,
      globalCounts,
      regionalCounts,
      hasFetched,
      publicPrefix: process.env.NODE_ENV === 'production' ? '' : '',
    }}
    />
  ) : (
    <div>
      <h1>Loading</h1>
    </div>
  );
};

export default PageRoot;
